import { createFormHookContexts, createFormHook } from '@tanstack/react-form'

export let { fieldContext, formContext, useFieldContext, useFormContext } = createFormHookContexts()

export let { useAppForm, withForm, useTypedAppFormContext, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {},
  formComponents: {},
})

export { default as FormField } from './FormField'
export { default as TextInput } from './TextInput'
export { default as SelectInput } from './SelectInput'
export { default as FileInput } from './FileInput'
